import BaseAdapter from '@/adapters/base_adapter'

export default class AlbumMediumAdapter extends BaseAdapter {
  get url() {
    return `${this.parent.url}/${this.data.uid}`
  }
}
